import React from 'react';

export type LandingFaqItem = { q: string; a: string };

export type LandingFaqProps = {
  id?: string;
  title: string;
  items: LandingFaqItem[];
};

const LandingFaq: React.FC<LandingFaqProps> = ({ id = 'faq-rubrik', title, items }) => (
  <section className="relative z-10 mx-auto mb-20 max-w-3xl" aria-labelledby={id}>
    <h2 id={id} className="mb-8 text-center text-3xl font-bold text-white">
      {title}
    </h2>
    <div className="space-y-3">
      {items.map((item) => (
        <details
          key={item.q}
          className="group border border-slate-800 bg-slate-900/40 p-4 open:border-purple-500/30"
        >
          <summary className="cursor-pointer list-none font-medium text-white marker:content-none [&::-webkit-details-marker]:hidden">
            <span className="flex items-center justify-between gap-2">
              {item.q}
              <span className="text-purple-400 transition-transform group-open:rotate-180">▼</span>
            </span>
          </summary>
          <p className="mt-3 border-t border-slate-800 pt-3 text-sm leading-relaxed text-slate-400">{item.a}</p>
        </details>
      ))}
    </div>
  </section>
);

export default LandingFaq;
